import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  LinearProgress,
  Stack,
  Typography,
  Menu,
  MenuItem,
  Paper,
  Skeleton,
  useMediaQuery,
  useTheme
} from "@mui/material";
import moment from "moment";
import { useSnackbar } from "notistack";
import { FileDownload } from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import transactionServices from "../services/transactionServices";
import {
  calculatePercent,
  convertToIndianFormat,
} from "../utils/functions";
import CustomIcon from "./customIcon";
import DataGridTable from "./DataGridTabel";
import { AmountPaidCommited, TxnRefNumber } from "./miniComponents";
import ConfirmaTransaction from "./modals/confirmTransaction";
import ModalComponent from "./modals/modalComponent";
import PaymentMode from "./modals/paymentMode";
import TransferTokenModal from "./modals/TransferTokenModal.js";
import Tabs from "./tabs/tabs";
import AllTransactionByListing from "./transactionTable/AllTransactionByListingNdUser";
import BeneficiaryCard from "../pages/marketPlace/property/BeneficiaryCard";
import { calculateTotalRetailCost } from "../utils/transactionCalculationFunction";
// import CollapsibleDataGridTable from "./collapsibleDataGridTable";
import BridgeModal from "./BridgeModal";
import { getTransactionHistory } from "../services/bridgeServices";
import TransactionHistoryModal from "../components/TranferHistory";

import CollapsibleDataGridTable from "./modals/collapsibleDataGridTable";
import DropdownMenuButton from "./DropdownMenuButton";
import TransactionsCardList from "./transactionCards/TransactionsCardList";
import TransactionStatusNode from "./transactionCards/TransactionStatusNode";
import PropertyCardsList from "./propertyCards/PropertyCardsList";
import logsService from "../services/logServices.js";
import InvestorActivityEventType from "../utils/eventTypes.js";
export const PropertyTable = ({
  sendDataToParent,
  isHuf,
  isFamilyMember,
  isTrust,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const user = useSelector((state) => state.user.data);
  const [data, setData] = useState([]);
  const [expandedChildren, setExpandedChildren] = useState({});
  const [openBeneficiary, setOpenBeneficiary] = useState(false);
  const [rightToOwnerShip, setRightToOwnerShip] = useState(false);
  const [beneficiaryInfo, setBeneficiaryInfo] = useState([]);
  const [listingId, setListingId] = useState("");
  const [entityId, setEntityId] = useState("");
  const [entityType, setEntityType] = useState("");
  const [propertyName, setPropertyName] = useState("");
  const [bridgeModalOpen, setBridgeModalOpen] = useState(false);
  const [openTransactionHistoryModal, setOpenTransationHistoryModal] = useState(false);
  const [selectedBridgeAccount, setSelectedBridgeAccount] = useState({ blockchain: 'Algorand', address: null, maxTokens: 0 });
  const [transactions, setTransactions] = useState([])
  const [selectedPropertyName, setSelectedPropertyName] = useState("")
  const getTransactions = async (entityId, listingId, rightToOwnerShip) => {
    try {
      const res = await getTransactionHistory(entityId, listingId, rightToOwnerShip)
      if (res && res.success) {
        // console.log(res.data)
        setTransactions(res.data)
      }
    }
    catch (error) {
      console.log('Error fetching HUF details:', error);
    }
  }
  const [showTransferTokenModal, setShowTransferTokenModal] = useState(false);
  const [transferTokenData, setTransferTokenData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleDownloadDocument = async (docUrl, docName, baseUrl = "") => {
    try {
      const response = await fetch(baseUrl + docUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = docName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch {
      window.open(baseUrl + docUrl, "_blank", "noopener,noreferrer");
    }
  };

  const PropertyActions = ({ row }) => {
    const handleSaleDeed = () => {
      if (row.saleDeed) {
        window.open("https://go.realx.in/sale-deed/" + row?.listingId, "_blank");
      } else {
        alert("sale deed not uploaded yet");
      }
    };

    const handleViewBeneficiary = () => {
      setListingId(row.listingId);
      setEntityId(row.entityId);
      setEntityType(row.entityType);
      setRightToOwnerShip(row.rightToOwnerShip === "RCO");
      setOpenBeneficiary(true);
      setPropertyName(row.propertyName);
    };

    const handleParawallet = () => {
      if (row.dltAccount) {
        const network = detectBlockchain(row.dltAccount);
        if (network === "Algorand") {
          window.open(
            `${process.env.REACT_APP_PARAWALLET_BASE_URL}/address/${row.dltAccount}`,
            "_blank",
            "noopener,noreferrer"
          );
        }
        else if (network === "Polygon") {
          window.open(
            `${process.env.REACT_APP_POLYGON_BASE_URL}/address/${row.dltAccount}`,
            "_blank",
            "noopener,noreferrer"
          );
        }
      }
    };

    const handleTransferToken = () => {
      setShowTransferTokenModal(true);
      setTransferTokenData(row);
    };

    const dropdownOptions = [
      {
        label: "View Sale Deed",
        icon: <CustomIcon name="file-document" sx={{ fontSize: "1.2rem" }} />,
        action: "saleDeed",
      },
      {
        label: "View Beneficiary",
        icon: <CustomIcon name="ownership" sx={{ fontSize: "1.2rem" }} />,
        action: "beneficiary",
      },
      ...(row.additionalDocuments || []).map((doc) => ({
        label: doc.docName,
        icon: <FileDownload sx={{ fontSize: "1.2rem" }} />,
        action: "downloadDocument",
        docUrl: doc.docUrl,
      })),
      ...(row.dltAccount && row.rightToOwnerShip === "Tokenization"
        ? [
          {
            label: "View Blockchain Account",
            icon: (
              <CustomIcon name="ownership" sx={{ fontSize: "1.2rem" }} />
            ),
            action: "blockchain",
          },
        ]
        : []),
      ...(row.rightToOwnerShip !== "RCO"
        ? [
          {
            label: "Transfer Token",
            icon: <CustomIcon name="ownership" sx={{ fontSize: "1.2rem" }} />,
            action: "bridge",
          },
        ]
        : []),
    ];

    const handleOptionClick = (option) => {
      switch (option.action) {
        case "saleDeed":
          handleSaleDeed();
          break;
        case "beneficiary":
          handleViewBeneficiary();
          break;
        case "bridge":
          handleTransferToken();
          break;
        case "blockchain":
          handleParawallet();
          break;
        case "downloadDocument":
          handleDownloadDocument(option.docUrl, option.label, row.baseUrl || "");
          break;
        default:
          break;
      }
    };

    return (
      <DropdownMenuButton options={dropdownOptions} onOptionClick={handleOptionClick} />
    );
  };

  const shorten = (val) => {
    if (!val || typeof val !== "string") return "-";
    const s = val.trim();
    if (s.length <= 14) return s;
    return `${s.slice(0, 6)}…${s.slice(-6)}`;
  };
  useEffect(() => {
    if (!user) return;
    getMyInvestments();
    // console.log("data",data)
  }, [isHuf, isFamilyMember, isTrust, user]);

  const handleTransactionHistory = async (userId, listingId, propertyName, rightToOwnerShip) => {
    // console.log("Transaction History clicked!");
    // console.log("User ID:", userId);
    // console.log("Listing ID:", listingId , propertyName , rightToOwnerShip);

    // You can do something here like:
    // navigate(`/transactions/${userId}/${listingId}`);
    // or open a modal, fetch transaction data, etc.
    await getTransactions(userId, listingId, rightToOwnerShip);
    setSelectedPropertyName(propertyName);
    setOpenTransationHistoryModal(true);
  };

  const getMyInvestments = async () => {
    try {
      setData([]);
      sendDataToParent([]);
      const data = {
        id: user._id,
        isHuf: isHuf,
        isFamilyMember: isFamilyMember,
        isTrust: isTrust,
      };
      const res = await transactionServices.getPrimaryAndSecondaryPortfolioDetails(data);

      if (res && res.success && res.data?.length > 0) {
        let tempData = [];
        for (let e of res.data) {
          sendDataToParent(res.data);
          if (!e?.listingId) continue;

          let temp = {
            propertyInfo: [
              e?.title,
              res.url + e?.listingImages || "",
              e?.projectName,
              e?.propertyCode,
            ],
            imgUrl: res.url + e?.listingImages[0]?.docUrl || "",
            propertyName: e?.title,
            rightToOwnerShip: e.rightToOwnerShip ? "RCO" : "Tokenization",
            propertyId: e.listingId,
            projectName: e.projectName,
            frax: e?.totalNoOfFracs,
            investAmt: `₹${e?.totalAmtPaid}`,
            pendingAmount: e.pendingAmt || 0,
            date:
              moment.unix(e.created_at).format("DD/MM/YYYY") || 12 / 12 / 2000,
            uDate:
              moment.unix(e.created_at).format("DD/MM/YYYY") || 12 / 12 / 2000,
            percentInvested: `${(e.totalNoOfFracs / e.listingNoOfFracs * 100).toFixed(2)} %`,
            status: e?.status,
            listingId: e.listingId,
            projectId: e.projectId,
            _id: e._id,
            id: e.listingId,
            transactionId: e.transactionId,
            saleDeed:
              res.url + (e?.listing?.registrationCertificate[0]?.docUrl || ""),
            ...(isFamilyMember && {
              username: e.username,
              relation: e.relation,
            }),
            entityId: e.entityId,
            entityType: e.entityType,
            tokenName: e?.assetclass?.tokenName,
            dltAccount: e.dltAccount,
            blockChainAssetId: e.blockChainAssetId,
            additionalDocuments: e.additionalDocuments || [],
            baseUrl: res.url,
            children: e.mergedTransactions?.map((tx, txIndex) => ({
              ...tx,
              id: tx._id, // unique id for child,
              percentage: tx?.noOfFracs / e.listingNoOfFracs * 100,
              frax: (tx?.noOfFracs || 0),
              tokenName: e?.assetclass?.tokenName,
              parentId: e.listingId,
              propertyName: e?.title,
              entityId: e.entityId,
              entityType: e.entityType,
              userId: e.userId,
              listingId: e.listingId,
              blockChainAssetId: e.blockChainAssetId,
              rpf: e.averageRpf,
              rightToOwnerShip: e.rightToOwnerShip ? "RCO" : "Tokenization",
              amoutPaid: `₹${tx?.totalAmtPaid}`,
              totalAmountInvested: e?.totalAmtPaid,
              totalTokens: e?.totalNoOfFracs,
              legalName: e.username || e.legalName || user?.legalName,
            })) || [],
            isChild: false
          };
          tempData.push(temp);
        }
        setData(tempData);
      } else {
        setData([]);
        // enqueueSnackbar(res?.data?.message || "Something went wrong", { variant: "error" });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const detectBlockchain = (address) => {
    if (!address) return "Unknown";

    // Polygon/EVM style
    if (address.startsWith("0x") && address.length === 42) {
      return "Polygon";
    }

    // Algorand style
    if (/^[A-Z2-7]{58}$/.test(address)) {
      return "Algorand";
    }

    return "Unknown";
  };


  function ActionMenu({ account, targetBlockchain, handleBridgeClick, handleViewBlockchain }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const sourceBlockchain = targetBlockchain === "Algorand" ? "Polygon" : "Algorand";

    const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
      <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginTop: "4px" }}>
        <Button
          size="small"
          variant="outlined"
          sx={{
            fontSize: "0.75rem",
            textTransform: "none",
            padding: "2px 10px",
          }}
          onClick={handleMenuClick}
        >
          Action
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            elevation: 3,
            sx: {
              borderRadius: "10px",
              mt: 0.5,
              minWidth: 170,
              "& .MuiMenuItem-root": {
                fontSize: "0.8rem",
                padding: "6px 14px",
              },
            },
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose();
              handleBridgeClick(
                (account.blockchain = sourceBlockchain),
                (account.accountAddress = account.dltAccount),
                (account.tokensHeld = account.numberOfFraxTransfered),
                account.listingId,
                account.userId
              );
            }}
          >
            Transfer to {targetBlockchain}
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleClose();
              handleViewBlockchain();
            }}
          >
            View Blockchain Account
          </MenuItem>
        </Menu>
      </div>
    );
  }
  const childCols = [
    {
      field: "blockChain",
      headerName: "Blockchain",
      flex: 1,
      renderCell: (params) => {
        const address = params.row.dltAccount;
        const blockchain = params.row.rightToOwnerShip === "Tokenization" ? detectBlockchain(address) : "-";

        return (
          <Typography variant="body3" sx={{ fontWeight: 500 }}>
            {blockchain}
          </Typography>
        );
      },
    },
    {
      field: "dltAccount",
      headerName: "Account Address",
      flex: 1.5,
      renderCell: (params) => {
        const walletName = params.row?.walletName || "Unnamed Wallet";
        const address = params.row.rightToOwnerShip === "Tokenization" ? params.row?.dltAccount : false;

        if (!address) return "—";

        const shortAddr = `${address.slice(0, 6)}...${address.slice(-4)}`;
        // console.log(shortAddr)

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontWeight: 500 }}>{walletName} - {shortAddr}</span>
            {/* <span> {shortAddr}</span> */}
          </div>
        );
      },
    },
    {
      field: "frax",
      headerName: "Number of Tokens",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body3">
          {params.row.frax} - {params.row.tokenName ? params.row.tokenName.toUpperCase() : "FRAX"}
        </Typography>
      ),
    },
    // {
    //   field: "amountPaid",
    //   headerName: "Total Amount Invested",
    //   flex: 1,
    //   valueFormatter: (params) => `₹${params?.toLocaleString("en-IN")}`,
    // },
    {
      field: "percentage",
      headerName: "Total Ownership",
      flex: 1,
      valueFormatter: (params) => `${params?.toFixed(2)}%`,
    },
    {
      field: "amoutPaid",
      headerName: "Total Amount Invested",
      flex: 1,
    },
    {
      field: " ",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        const { dltAccount } = params.row;
        const handleTransferToken = () => {
          setShowTransferTokenModal(true);
          setTransferTokenData(params.row);
        };
        const handleParawallet = () => {
          if (dltAccount) {
            let explorerlink = null;
            const network = detectBlockchain(dltAccount).toLowerCase();

            switch (network) {
              case 'algorand':
                explorerlink = `${process.env.REACT_APP_PARAWALLET_BASE_URL}/address/${dltAccount}`;
                break;
              case 'polygon':
                explorerlink = `${process.env.REACT_APP_POLYGON_BASE_URL}/address/${dltAccount}`;
                break;
              default:
                throw new Error('unsupported network: ' + network);
            }
            window.open(
              `${explorerlink}`,
              "_blank",
              "noopener,noreferrer"
            );
          }
        };


        const handleBridgeClick = () => {
          const address = params.row.dltAccount;
          const blockchain = detectBlockchain(address);
          const targetBlockchain = blockchain === "Algorand" ? "Polygon" : "Algorand";
          const entityType = params.row.entityType;
          // console.log("params.row" , params.row)

          let entityId = params.row.entityId;
          if (entityType == 'PERSONAL') {
            entityId = params.row.userId;
          }

          // console.log("entityId" , entityId , params.row.entityType)
          let totalTokens = params.row.totalTokens;
          let totalAmountInvested = params.row.totalAmountInvested;
          let rpf = totalAmountInvested / totalTokens



          setSelectedBridgeAccount({
            blockchain,           // Current blockchain
            targetBlockchain,     // Destination blockchain
            address,
            maxTokens: params.row.frax,
            listingId: params.row.listingId,
            entityId: entityId,
            entityType: params.row.entityType,
            rpf: rpf,
            senderAddress: params.row.dltAccount,
            userId: params.row.userId,
            blockChainAssetId: params.row.blockChainAssetId
          });

          setBridgeModalOpen(true);
        };


        // Detect current network
        const currentNetwork = detectBlockchain(dltAccount);
        const bridgeLabel = currentNetwork === "Algorand" ? "Transfer to Polygon" : "Transfer to Algorand";

        let dropdownOptions = [
          {
            label: "Transfer Token",
            icon: <CustomIcon name="token" sx={{ fontSize: '1.2rem' }} />,
            action: "transfer"
          },
          {
            label: "View Blockchain Account",
            icon: <CustomIcon name="token" sx={{ fontSize: '1.2rem' }} />,
            action: "view"
          },
          // {
          //   label: bridgeLabel,
          //   icon: <CustomIcon name="token" sx={{ fontSize: '1.2rem' }} />,
          //   action: "bridge-transfer"
          // }
        ];

        const handleOptionClick = (option) => {
          switch (option.action) {
            case "transfer":
              handleTransferToken();
              break;
            case "view":
              handleParawallet();
              break;
            case "bridge-transfer":
              handleBridgeClick();
              break;
            default:
              break;
          }
        };

        // 🧠 Hide "Transfer Token" if network is Polygon
        if (currentNetwork?.toLowerCase() === "polygon") {
          dropdownOptions = dropdownOptions.filter(
            (opt) => opt.action !== "transfer"
          );
        }

        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <DropdownMenuButton
              options={dropdownOptions}
              onOptionClick={handleOptionClick}
            />
          </div>
        );
      },
    },

  ];

  // Function to get child columns based on parent row's rightToOwnerShip
  const getChildColsForRow = (parentRow) => {
    // If parent is RCO, exclude the Actions column
    if (parentRow.rightToOwnerShip === "RCO") {
      return childCols.filter(col => col.field !== " ");
    }
    return childCols;
  };

  const tabel = [
    {
      field: "imgUrl",
      headerName: "Asset Image",
      flex: 1,
      renderCell: (params) => {
        "";
        return (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                padding: "2px",
              }}
            >
              <img
                src={params.row.imgUrl}
                alt="Property"
                style={{ width: "100px", height: "auto", borderRadius: "4px" }}
              />
            </div>
          </>
        );
      },
    },
    { field: "propertyName", headerName: "Asset Name", flex: 1 },
    {
      field: "investAmt",
      headerName: "Total Tokens Value",
      flex: 1,
    },
    {
      field: "frax",
      headerName: "Total No of Token",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography variant="body3">
            {params.row.frax
              ? `${params.row.frax}-${params.row.tokenName
                ? params.row.tokenName.toUpperCase()
                : "FRAX"
              }`
              : "0"}
          </Typography>
        );
      },
    },
    { field: "rightToOwnerShip", headerName: "Investment Mode", flex: 1 },
    isFamilyMember && {
      field: "username",
      headerName: "Investor Name",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography variant="body3">
            {params.row.username
              ? `${params.row.username}(${params.row.relation})`
              : "Family"}
          </Typography>
        );
      },
    },
    { field: "percentInvested", headerName: "Total % Ownership", flex: 1 },
    {
      field: "prop",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <PropertyActions row={params.row} />
          </div>
        )
      },
    },
  ].filter(Boolean);

  const childCols1 = [
    {
      field: "blockChain",
      headerName: "Blockchain",
      flex: 1,
      renderCell: (params) => {
        const address = params.row.dltAccount;
        const blockchain = detectBlockchain(address);

        return (
          <Typography variant="body3" sx={{ fontWeight: 500 }}>
            {blockchain}
          </Typography>
        );
      },
    },
    {
      field: "dltAccount",
      headerName: "Account Address",
      flex: 1.5,
      renderCell: (params) => (
        <Typography
          variant="body3"
          sx={{
            fontFamily: "monospace",
            fontSize: "0.8rem",
            wordBreak: "break-all",
          }}
        >
          {params.row.dltAccount}
        </Typography>
      ),
    },
    {
      field: "numberOfFraxTransfered",
      headerName: "Number of Tokens",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body3">
          {params.row.numberOfFraxTransfered} FRAX
        </Typography>
      ),
    },
    {
      field: "percentage",
      headerName: "Total Ownership",
      flex: 1,
      valueFormatter: (params) => `${params.toFixed(2)}%`,
    },
    {
      field: "amtPaidForDlt",
      headerName: "Total Amount Invested",
      flex: 1,
      valueFormatter: (params) => `₹${params?.toLocaleString("en-IN")}`,
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   flex: 2,
    //   sortable: false,
    //   renderCell: (params) => {
    //     const account = params.row;
    //     const targetBlockchain =
    //       account.blockchain === "Algorand" ? "Polygon" : "Algorand";

    //     const handleBridgeClick = (blockchain, address, maxTokens , listingId , userId) => {
    //       setSelectedBridgeAccount({ blockchain, address, maxTokens , listingId , entityId:userId});
    //       setBridgeModalOpen(true);
    //     };

    //     const handleViewBlockchain = () => {
    //       console.log("View blockchain account:", account);
    //       if (account.dltAccount) {
    //             window.open(
    //               `https://testnet.explorer.perawallet.app/address/${account.dltAccount}`,  //remove testnet for mainnet
    //               '_blank',
    //               'noopener,noreferrer'
    //             );
    //           }
    //       // Implement blockchain explorer link here
    //     };

    //     return (
    //       <div style={{ display: "flex", justifyContent: "center",gap:"15px",marginTop:"4px" }}>
    //         <Button
    //           size="small"
    //           variant="outlined"
    //           sx={{ fontSize: "0.75rem", textTransform: "none" }}
    //           onClick={() => handleBridgeClick(
    //           account.blockchain = 'Algorand',
    //           account.accountAddress = account.dltAccount,
    //           account.tokensHeld = account.numberOfFraxTransfered,
    //           account.listingId,
    //           account.userId
    //         )}
    //         >
    //           Bridge to {targetBlockchain}
    //         </Button>
    //         <Button
    //           size="small"
    //           variant="outlined"
    //           sx={{ fontSize: "0.75rem", textTransform: "none" }}
    //           onClick={handleViewBlockchain}
    //         >
    //           View Blockchain Account
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        const account = params.row;
        const address = params.row.dltAccount;
        const blockchain = detectBlockchain(address);
        const targetBlockchain = blockchain === "Algorand" ? "Polygon" : "Algorand";

        const handleBridgeClick = (blockchain, address, maxTokens, listingId, userId) => {
          setSelectedBridgeAccount({ blockchain, address, maxTokens, listingId, entityId: userId });
          setBridgeModalOpen(true);
        };

        const handleViewBlockchain = () => {
          let explorerlink;
          if (account.dltAccount) {
            let network = detectBlockchain(account.dltAccount).toLowerCase();
            console.log(network)
            let env = process.env.REACT_APP_BLOCKCHAIN_NET;
            switch (network) {
              case 'algorand':
                explorerlink = `https://${env === 'mainnet' ? 'explorer' : 'testnet'}.explorer.perawallet.app/address/${account.dltAccount}`;
                break;
              case 'polygon':
                explorerlink = `https://${env === 'mainnet' ? 'polygon' : 'polygon-test'}.explorer.perawallet.app/address/${account.dltAccount}`;
                break;
              default:
                throw new Error('unsupported network: ' + network);
            }

          }

          window.open(
            explorerlink,
            "_blank",
            "noopener,noreferrer"
          );
        };

        return (
          <ActionMenu
            account={account}
            targetBlockchain={targetBlockchain}
            handleBridgeClick={handleBridgeClick}
            handleViewBlockchain={handleViewBlockchain}
          />
        );
      },
    },

  ];

  if (data.length === 0)
    return (
      <EmptyTableState
        showAction={true}
        title={"No Properties"}
        subtitle={"You've not made any investments yet."}
      />
    );

  return (
    <>
      {openBeneficiary && (
        <ModalComponent
          titleStyle={{ fontWeight: 500, fontSize: "1.3rem !important" }}
          children={
            <BeneficiaryCard
              beneficiaryInfo={beneficiaryInfo}
              setBeneficiaryInfo={setBeneficiaryInfo}
              entityId={entityId}
              entityType={entityType}
              rightToOwnerShip={rightToOwnerShip}
              selectedMode={rightToOwnerShip ? 1 : 0}
              listingId={listingId}
              user={user}
              showButton={true}
            />
          }
          open={openBeneficiary}
          handleClose={() => setOpenBeneficiary(false)}
          title={`Beneficiaries for ${propertyName}`}
        />
      )}
      <TransferTokenModal
        open={showTransferTokenModal}
        data={transferTokenData}
        onClose={() => {
          setShowTransferTokenModal(false);
          setTransferTokenData(null);
          getMyInvestments()
        }}
      />
      {isMobile ? (
        <PropertyCardsList
          rows={data}
          isFamilyMember={isFamilyMember}
          detectBlockchain={detectBlockchain}
          onToggleChildren={(row) =>
            setExpandedChildren((prev) => ({ ...prev, [row._id]: !prev[row._id] }))
          }
          isChildrenExpanded={(row) => Boolean(expandedChildren[row._id])}
          renderParentActions={(row) => <PropertyActions row={row} />}
          renderChildActions={(parentRow, childRow) => (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <ActionMenu
                account={{
                  ...childRow,
                  dltAccount: childRow.dltAccount,
                  numberOfFraxTransfered:
                    childRow.frax ?? childRow.numberOfFraxTransfered,
                  listingId: childRow.listingId || parentRow.listingId,
                  userId: childRow.userId,
                }}
                targetBlockchain={
                  detectBlockchain(childRow.dltAccount) === "Algorand"
                    ? "Polygon"
                    : "Algorand"
                }
                handleBridgeClick={(blockchain, address, maxTokens, listingId, userId) => {
                  if (parentRow.rightToOwnerShip === "RCO") return;
                  setSelectedBridgeAccount({
                    blockchain,
                    address,
                    maxTokens,
                    listingId,
                    entityId: userId,
                  });
                  setBridgeModalOpen(true);
                }}
                handleViewBlockchain={() => {
                  let explorerlink;
                  if (childRow.dltAccount) {
                    let network = detectBlockchain(childRow.dltAccount).toLowerCase();
                    let env = process.env.REACT_APP_BLOCKCHAIN_NET;
                    switch (network) {
                      case "algorand":
                        explorerlink = `https://${env === "mainnet" ? "explorer" : "testnet"}.explorer.perawallet.app/address/${childRow.dltAccount}`;
                        break;
                      case "polygon":
                        explorerlink = `https://${env === "mainnet" ? "polygon" : "polygon-test"}.explorer.perawallet.app/address/${childRow.dltAccount}`;
                        break;
                      default:
                        explorerlink = "";
                    }
                  }
                  if (explorerlink) window.open(explorerlink, "_blank", "noopener,noreferrer");
                }}
              />
            </Box>
          )}
        />
      ) : (
        <CollapsibleDataGridTable
          parentRows={data}
          parentColumns={tabel}
          childColumns={childCols}
          childFieldName="children"
          initialPageSize={5}
          getChildColumnsForRow={getChildColsForRow}
        />
      )}
      {/* {openTransactionModal && (
                <ModalComponent
                    open={openTransactionModal}
                    handleClose={() => setOpenTransationModal((prev) => !prev)}
                    title="All Transaction"
                    titleStyle={{ fontWeight: 400, mb: 1, pl: 1, fontSize: "1.4rem !important" }}
                    children={<AllTransactionByListing data={transactionProp} />}
                />
            )} */}


      {bridgeModalOpen && <BridgeModal
        isOpen={bridgeModalOpen}
        onClose={() => {
          setBridgeModalOpen(false);      // close the modal
          getMyInvestments();             // refresh the investments
        }}
        sourceBlockchain={selectedBridgeAccount?.blockchain || ""}
        sourceAddress={selectedBridgeAccount?.address || ""}
        maxTokens={selectedBridgeAccount?.maxTokens || 0}
        listingId={selectedBridgeAccount?.listingId || null}
        entityId={selectedBridgeAccount?.entityId || null}
        entityType={selectedBridgeAccount?.entityType}
        rpf={selectedBridgeAccount?.rpf}
        senderAddress={selectedBridgeAccount?.senderAddress}
        userId={selectedBridgeAccount?.userId}
        blockChainAssetId={selectedBridgeAccount?.blockChainAssetId}
      />
      }

      {/* Transaction History Modal */}
      <TransactionHistoryModal
        open={openTransactionHistoryModal}
        onClose={() => setOpenTransationHistoryModal(false)}
        transactions={transactions}
        setTransactions={setTransactions}
        selectedPropertyName={selectedPropertyName}
        setSelectedPropertyName={setSelectedPropertyName}
      />

    </>
  );
};

export const WatchListTable = ({ watchlist }) => {
  // const generatePropertyName = (propertyData) => {
  //     if (propertyData?.propertyType === "Residential") return `${propertyData?.basicInfo?.flatNo}, Wing-${propertyData?.basicInfo?.wing}`
  //     if (propertyData?.propertyType === "Commercial" || propertyData?.propertyType === "Retail") return `${propertyData?.basicInfo?.unitNo}, Wing-${propertyData?.basicInfo?.wing}`
  //     if (propertyData?.propertyType === "Land") return `Plot No. ${propertyData?.basicInfo?.plotNo} - ${propertyData?.project?.projectName}`
  //     if (propertyData?.propertyType === "Warehouse") return `Warehouse No. ${propertyData?.basicInfo?.warehouseNo}`
  //     return "";
  // }

  const [data, setData] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();

  useEffect(() => {
    const temp = [];
    if (watchlist && watchlist.length > 0 && watchlist[0]?._id) {
      watchlist.map((e) => {
        temp.push({
          _id: e._id,
          propertyName: e?.title,
          propertyType: e.propertyType,
          totalPurchasePrice: convertToIndianFormat(
            e.transactionDetails?.totalCostOfPurchase
          ),
          totalInvestors: e.transactions?.investors?.length || 0,
          filled: `${calculatePercent(
            e.numberOfFracs - e.remainingFracs,
            e.numberOfFracs
          ).toFixed(2)} %`,
          status: e.status,
          totalAmount: calculateTotalRetailCost(e, e?.assetClass?.fields),
        });
        return null;
      });
    }
    setData(temp);
  }, [watchlist]);

  const table = [
    { field: "propertyName", headerName: "Property Name", flex: 1 },
    { field: "propertyType", headerName: "Property Type", flex: 1 },
    {
      field: "totalAmount",
      headerName: "Total Purchase Price",
      flex: 1,
      valueFormatter: (params) => {
        return `₹${params.toLocaleString("en-IN")}`;
      },
    },
    { field: "totalInvestors", headerName: "Total no of investors", flex: 1 },
    { field: "filled", headerName: "% Filled", flex: 1 },
    {
      field: "prop",
      headerName: "",
      flex: 1,
      renderCell: (params) => {
        const handleClick = () => {
          navigate(`/dashboard/property/${params.row._id}`, {
            state: { id: params.row._id },
          });
        };

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {params.row.status === "COMPLETED" ? (
              <Chip
                label="Fully Subscribed"
                variant="outlined"
                sx={{
                  color: "#ff7676",
                  fontWeight: "bold",
                  fontSize: "0.8rem",
                  padding: "5px 10px",
                  border: "none",
                }}
              />
            ) : (
              <Button
                onClick={handleClick}
                style={{ padding: "12px 15px" }}
                variant="outlined"
              >
                Show Property
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  const WatchlistCards = ({ rows }) => {
    const formatINR = (amount) => {
      if (typeof amount !== "number" || Number.isNaN(amount)) return "-";
      return `₹${amount.toLocaleString("en-IN")}`;
    };

    const parsePercent = (val) => {
      if (val == null) return null;
      if (typeof val === "number") return Number.isFinite(val) ? val : null;
      if (typeof val !== "string") return null;
      const n = parseFloat(val.replace("%", "").trim());
      return Number.isFinite(n) ? n : null;
    };

    return (
      <Stack spacing={1.5}>
        {rows.map((row) => {
          const handleClick = () => {
            navigate(`/dashboard/property/${row._id}`, {
              state: { id: row._id },
            });
          };

          const filledPct = parsePercent(row.filled);
          const isCompleted = row.status === "COMPLETED";

          return (
            <Card
              key={row._id}
              variant="outlined"
              onClick={handleClick}
              sx={{
                borderRadius: 2,
                cursor: "pointer",
                transition: "transform 120ms ease, box-shadow 120ms ease",
                "&:active": { transform: "scale(0.99)" },
                "&:hover": { boxShadow: 2 },
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Stack spacing={1.25}>
                  <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1.5}>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          lineHeight: 1.2,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {row.propertyName || "-"}
                      </Typography>

                      <Stack direction="row" spacing={1} sx={{ mt: 0.75, flexWrap: "wrap" }}>
                        {row.propertyType ? (
                          <Chip
                            size="small"
                            label={row.propertyType}
                            sx={{ bgcolor: "action.hover", fontWeight: 600 }}
                          />
                        ) : null}
                        {isCompleted ? (
                          <Chip
                            size="small"
                            label="Fully Subscribed"
                            sx={{
                              bgcolor: "rgba(255, 118, 118, 0.14)",
                              color: "#ff7676",
                              fontWeight: 700,
                            }}
                          />
                        ) : (
                          <Chip
                            size="small"
                            label={row.status || "Open"}
                            sx={{ bgcolor: "rgba(47, 107, 242, 0.10)", color: "primary.main", fontWeight: 700 }}
                          />
                        )}
                      </Stack>
                    </Box>

                    <Stack alignItems="flex-end" spacing={0.25} sx={{ pl: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        Total price
                      </Typography>
                      <Typography sx={{ fontWeight: 800 }}>{formatINR(row.totalAmount)}</Typography>
                    </Stack>
                  </Stack>

                  <Box sx={{ mt: 0.5 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                      <Typography variant="caption" color="text.secondary">
                        Filled
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 700 }}>
                        {row.filled || "-"}
                      </Typography>
                    </Stack>
                    <LinearProgress
                      variant={typeof filledPct === "number" ? "determinate" : "indeterminate"}
                      value={typeof filledPct === "number" ? Math.min(100, Math.max(0, filledPct)) : undefined}
                      sx={{
                        height: 8,
                        borderRadius: 999,
                        bgcolor: "action.hover",
                        "& .MuiLinearProgress-bar": { borderRadius: 999 },
                      }}
                    />
                  </Box>

                  <Grid container spacing={1} sx={{ pt: 0.25 }}>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">
                        Investors
                      </Typography>
                      <Typography sx={{ fontWeight: 700 }}>
                        {typeof row.totalInvestors === "number" ? row.totalInvestors : "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">
                        Investment
                      </Typography>
                      <Typography sx={{ fontWeight: 700 }}>{row.status === "COMPLETED" ? "Closed" : "Open"}</Typography>
                    </Grid>
                  </Grid>

                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClick();
                    }}
                    variant={isCompleted ? "outlined" : "contained"}
                    fullWidth
                    sx={{ textTransform: "none", fontWeight: 700 }}
                  >
                    {isCompleted ? "View Property" : "View & Invest"}
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          );
        })}
      </Stack>
    );
  };

  if (data.length > 0) {
    if (isMobile) return <WatchlistCards rows={data} />;
    return <DataGridTable initialColumns={table} initialRows={data} />;
  } else {
    return (
      <EmptyTableState
        showAction={true}
        title={"No Properties"}
        subtitle={""}
      />
    );
  }
};

export const EmptyTableState = ({ showAction = false, title, subtitle }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        flex: 1,
        width: "100%",
      }}
    >
      <Stack
        height={"100%"}
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          sx={{
            width: { md: 160, xs: 88 },
            height: { md: 160, xs: 88 },
            bgcolor: "primary.light",
            borderRadius: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { md: 0, xs: 3 },
          }}
        >
          <CustomIcon
            name="file-document"
            sx={{
              bgcolor: "primary.main",
              width: { md: 72, xs: 32 },
              height: { md: 72, xs: 32 },
            }}
          />
        </Box>
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: 500,
            mt: { md: 4, xs: 3 },
            mb: { md: 1.5, xs: 0.5 },
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ fontSize: "16px", fontWeight: 300, mb: { md: 3, xs: 2 } }}
        >
          {subtitle}
        </Typography>
        {showAction && (
          <Button
            onClick={() => navigate("/dashboard")}
            sx={{ mb: { md: 0, xs: 3 } }}
            variant="contained"
          >
            Explore Properties to invest
          </Button>
        )}
      </Stack>
    </Box>
  );
};

const TransactionsCardSkeleton = () => (
  <Card sx={{ boxShadow: 1, borderRadius: 2 }}>
    <CardContent>
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="flex-start"
        sx={{ "@media (max-width:500px)": { flexDirection: "column" } }}
      >
        <Skeleton
          variant="rounded"
          sx={{
            width: 92,
            height: 68,
            flex: "0 0 auto",
            borderRadius: 1.5,
            "@media (max-width:500px)": { width: "100%", height: 140 },
          }}
        />
        <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1, width: "100%" }}>
          <Skeleton variant="text" width="70%" height={24} />
          <Skeleton variant="text" width="45%" height={18} />
          <Skeleton variant="rounded" width={110} height={24} sx={{ mt: 0.75 }} />
        </Stack>
      </Stack>

      <Divider sx={{ my: 1.5 }} />

      <Stack spacing={1.25}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Stack key={i} direction="row" justifyContent="space-between" spacing={2}>
            <Skeleton variant="text" width="30%" height={18} />
            <Skeleton variant="text" width="25%" height={18} />
          </Stack>
        ))}
      </Stack>

      <Skeleton variant="rounded" width="100%" height={36} sx={{ mt: 2 }} />
    </CardContent>
  </Card>
);

const TransactionsCardsSkeleton = ({ rows = 4 }) => (
  <Stack
    spacing={2}
    sx={{ px: { xs: 2, sm: 3 }, py: { xs: 2, sm: 3 }, pb: { xs: "77px", md: 3 } }}
  >
    {Array.from({ length: rows }).map((_, i) => (
      <TransactionsCardSkeleton key={i} />
    ))}
  </Stack>
);

export const TransactionsTable = ({
  transactionsDetails,
  getTransactionDetails,
  title,
  tableLoading = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [paymentModeModal, setPaymentModeModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [commitmentDate, setCommitmentDate] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const [currentTraxn, setCurrentTraxn] = useState();
  const [openTransactionModal, setOpenTransationModal] = useState(false);
  const [transactionProp, setTransactionProp] = useState({});
  const [status, setStatus] = useState();
  const [noOfFrax, setNoOfFrax] = useState();
  const [propertyId, setPropertyId] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [paymentAccount, setPaymentAccount] = useState(false);
  const [entityId, setEntityId] = useState("");
  const [entityType, setEntityType] = useState("");
  const [tokenName, setTokenName] = useState("");
  const [loading, setLoading] = useState(false);
  const [upiModal, setUpiModal] = useState(false);
  const [upiTransactionId, setUpiTransactionId] = useState(null);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleCompleteRemainingPayment = (row) => {
    setCurrentTraxn(row);
    handleCompletePayment(row?.pendingAmt);
    setCommitmentDate(row?.commitmentDate);
    setEntityId(row.entityId || row.user_id);
    setEntityType(row.entityType);
    setTokenName(row.tokenName);
  };

  const renderAmount = (row) =>
    row.status === "REFUNDED" ? (
      <Typography variant="body3">-</Typography>
    ) : (
      <AmountPaidCommited data={row} />
    );

  const handleViewPayments = (row) => {
    setTokenName(row.tokenName);
    setTransactionProp(row.payments);
    setStatus(row.status);
    setNoOfFrax(row.noOfFracs);
    setPropertyId(row.listingId);
    setOpenTransationModal((prev) => !prev);
  };
  const getLastPaymentDate = (payments) => {
    if (!payments || payments.length === 0) return "-";
    for (let i = payments.length - 1; i >= 0; i--) {
      if (payments[i].status !== "REFUNDED" && payments[i].dateoftrans) {
        return moment.unix(payments[i].dateoftrans).format("DD/MM/YYYY");
      }
    }
    return "-";
  };

  const data = useMemo(() => {
    const temp = [];
    if (transactionsDetails && transactionsDetails.length > 0) {
      transactionsDetails.map((e) => {
        temp.push({
          _id: e._id,
          listingId: e.listingId,
          propertyInfo: [
            e?.listing?.title || "",
            transactionsDetails[0].url + e?.listing?.listingImages[0]?.docUrl ||
            "",
            e.project?.projectName,
            e.listing?.propertyCode,
          ],
          imgUrl:
            transactionsDetails[0].url + e?.listing?.listingImages[0]?.docUrl ||
            "",
          lastPaymentDate: getLastPaymentDate(e?.payments),
          payments:
            e?.payments?.map((payment) => ({
              ...payment,
              rpf: e?.rpf,
              amount: e?.amount,
              propertyCode: e?.listing?.propertyCode,
              propertyName: e?.listing?.title,
              investorName: e.investorName,
            })) || [],
          rpf: (e?.rpf || e?.amount / e?.noOfFracs)?.toFixed(2),
          projectName: e.project?.projectName,
          propertyName: e?.listing?.title,
          propertyType: e.listing?.propertyType,
          amount: e?.amount,
          amtTobePaid: e?.amtTobePaid || 0,
          noOfFracs: e.status == "REFUNDED" ? "-" : e?.noOfFracs || 0,
          propertyPercent: e.propertyPercent,
          propertyStatus: e.listing?.status || "",
          pendingAmt: e.pendingAmt || 0,
          highValueCashback: e.highValueCashback,
          created_at: moment(e.created_at).format("DD/MM/YYYY"),
          updated_at: moment(e.updated_at).format("DD/MM/YYYY"),
          commitmentDate: e.created_at,
          couponCashback: e.couponCashback,
          status: e.status,
          transactionId: e.transactionId,
          newpaymentMade: e.newpaymentMade,
          fraxFree: e.fraxFree,
          amtPaid: e.amtPaid,
          user_id: e.user_id,
          entityType: e.entityType,
          entityId: e.entityId,
          username: e.familyMember?.username,
          relation: e.entityInvestor?.relation,
          isRefunded: e.isRefunded,
          purpose: e.purpose,
          tokenName: e?.assetclass?.tokenName
            ? e?.assetclass?.tokenName.toUpperCase()
            : "FRAX",
        });

        return null;
      });
    }
    return temp;
  }, [transactionsDetails]);

  const huftransaction = data.filter(
    (transaction) => transaction.entityType === "HUF"
  );
  const trusttransaction = data.filter(
    (transaction) => transaction.entityType === "TRUST"
  );

  const familymemberTransaction = data.filter(
    (data) => data.entityType === "FAMILYMEMBER"
  );
  const personalTransaction = data.filter(
    (transaction) => transaction.entityType === "PERSONAL"
  );

  const table = [
    {
      field: "imgUrl",
      headerName: "Asset Image",
      flex: 1,
      renderCell: (params) => {
        const isReferralReward = params.row.purpose === "REFERRAL_REWORD" || params.row.purpose === "FOUNDER_CIRCLE_REWORD";

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              padding: "2px",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100px",
                overflow: "hidden",
                borderRadius: "4px",
              }}
            >
              <img
                src={params.row.imgUrl}
                alt="Property"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  borderRadius: "4px",
                }}
              />
              {isReferralReward && (
                <div
                  style={{
                    position: "absolute",
                    top: 9,
                    left: -14,
                    width: 70,
                    backgroundColor: "#FF382D",
                    color: "#fff",
                    fontSize: "7px",
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    textAlign: "center",
                    lineHeight: 1.2,
                    padding: "2px 10px",
                    boxSizing: "border-box",
                    transform: "rotate(-45deg)",
                    zIndex: 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  {params.row.purpose === "REFERRAL_REWORD" ? "REWORD" : "F.C REWORD"}
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    { field: "propertyName", headerName: "Asset Name", flex: 1 },
    {
      field: "amount",
      headerName: "Amount Paid/ Commited",
      flex: 1.5,
      valueFormatter: (params) => {
        return `₹${params.toLocaleString("en-IN")}`;
      },
      renderCell: (params) => {
        // console.log(params.row); // Logs the row data (useful for debugging)
        return params.row.status == "REFUNDED" ? (
          <Typography variant="body3">-</Typography>
        ) : (
          <AmountPaidCommited data={params.row} />
        ); // Calls the AmountPaidCommited component
      },
    },
    { field: "noOfFracs", headerName: "No of Token", flex: 1 },
    // { field: 'rpf', headerName: 'Rate /FRAX', flex: 1 },
    paymentAccount
      ? {
        field: "isHuf",
        headerName: "Payment Account",
        flex: 1.5,
        alignItems: "center",
        textAlign: "center",
        renderCell: (params) => {
          if (params.row.entityType === "HUF") {
            return <Typography variant="body3">HUF</Typography>;
          } else if (params.row.entityType === "TRUST") {
            return <Typography variant="body3">TRUST</Typography>;
          } else if (params.row.entityType === "FAMILYMEMBER") {
            return (
              <Typography variant="body3">
                {params.row?.username
                  ? `${params.row?.username}(${params.row?.relation})`
                  : "Family"}
              </Typography>
            );
          } else {
            return <Typography variant="body3">Personal</Typography>;
          }
        },
      }
      : null,
    { field: "created_at", headerName: "Committed Date", flex: 1 },
    { field: "lastPaymentDate", headerName: "Last Txn Date", flex: 1 },
    {
      field: "transactionId",
      headerName: "Transaction Ref No",
      flex: 1,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
              padding: "2px",
            }}
          >
            {" "}
            <TxnRefNumber elemProps={params.row.transactionId} />{" "}
          </div>
        );
      },
    },
    {
      field: "click",
      headerName: "Status",
      flex: 2.5,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <TransactionStatusNode
              row={params.row}
              fullWidthAction={false}
              onCompleteRemainingPayment={handleCompleteRemainingPayment}
            />
          </div>
        );
      },
    },
    {
      field: "proop",
      headerName: "",
      flex: 1.5,
      renderCell: (params) => {
        const handleClick = () => {
          setTokenName(params.row.tokenName);
          setTransactionProp(params.row.payments);
          setStatus(params.row.status);
          setNoOfFrax(params.row.noOfFracs);
          setPropertyId(params.row.listingId);
          setOpenTransationModal((prev) => !prev);
        };

        return (
          <Button
            onClick={handleClick}
            style={{ padding: "10px", fontSize: "12px" }}
            variant="contained"
          >
            {"View Payments"}
          </Button>
        );
      },
    },
  ].filter(Boolean);

  const tabs = [
    {
      name: title || "All",
      tab: (
        isMobile ? (
          <TransactionsCardList
            rows={data}
            showPaymentAccount={true}
            renderAmount={renderAmount}
            onCompleteRemainingPayment={handleCompleteRemainingPayment}
            onViewPayments={handleViewPayments}
            emptyState={
              <EmptyTableState
                showAction={false}
                title={"No Transactions Available"}
                subtitle={""}
              />
            }
          />
        ) : (
          <AllTranSaction
            data={data}
            table={table}
            setPaymentAccount={setPaymentAccount}
          />
        )
      ),
    },
    {
      name: title || "Personal",
      tab: (
        isMobile ? (
          <TransactionsCardList
            rows={personalTransaction}
            showPaymentAccount={false}
            renderAmount={renderAmount}
            onCompleteRemainingPayment={handleCompleteRemainingPayment}
            onViewPayments={handleViewPayments}
            emptyState={
              <EmptyTableState
                showAction={false}
                title={"No Transactions Available"}
                subtitle={""}
              />
            }
          />
        ) : (
          <PersonalTransaction
            data={personalTransaction}
            table={table}
            setPaymentAccount={setPaymentAccount}
          />
        )
      ),
    },
    familymemberTransaction?.length > 0
      ? {
        name: title || "Family Member",
        tab: (
          isMobile ? (
            <TransactionsCardList
              rows={familymemberTransaction}
              showPaymentAccount={true}
              renderAmount={renderAmount}
              onCompleteRemainingPayment={handleCompleteRemainingPayment}
              onViewPayments={handleViewPayments}
              emptyState={
                <EmptyTableState
                  showAction={false}
                  title={"No Transactions Available"}
                  subtitle={""}
                />
              }
            />
          ) : (
            <FamilyMemberTransaction
              data={familymemberTransaction}
              table={table}
              setPaymentAccount={setPaymentAccount}
            />
          )
        ),
      }
      : null,
    huftransaction?.length > 0
      ? {
        name: title || "HUF",
        tab: (
          isMobile ? (
            <TransactionsCardList
              rows={huftransaction}
              showPaymentAccount={false}
              renderAmount={renderAmount}
              onCompleteRemainingPayment={handleCompleteRemainingPayment}
              onViewPayments={handleViewPayments}
              emptyState={
                <EmptyTableState
                  showAction={false}
                  title={"No Transactions Available"}
                  subtitle={""}
                />
              }
            />
          ) : (
            <HUFTransaction
              data={huftransaction}
              table={table}
              setPaymentAccount={setPaymentAccount}
            />
          )
        ),
      }
      : null,
    trusttransaction?.length > 0
      ? {
        name: title || "Trust",
        tab: (
          isMobile ? (
            <TransactionsCardList
              rows={trusttransaction}
              showPaymentAccount={false}
              renderAmount={renderAmount}
              onCompleteRemainingPayment={handleCompleteRemainingPayment}
              onViewPayments={handleViewPayments}
              emptyState={
                <EmptyTableState
                  showAction={false}
                  title={"No Transactions Available"}
                  subtitle={""}
                />
              }
            />
          ) : (
            <TrustTransaction
              data={trusttransaction}
              table={table}
              setPaymentAccount={setPaymentAccount}
            />
          )
        ),
      }
      : null,
  ].filter(Boolean);

  const handleCompletePayment = (amount) => {
    setPaymentModeModal(true);
  };
  const handleBankTransfer = () => {
    setPaymentModeModal(false);
    setPaymentModal(true);
  };

  const onUPI = async () => {
    try {
      setLoading(true);
      setPaymentModeModal(false);
      const initiated = await handleUPIInitiate();
      if (initiated) setUpiModal(true);
    } catch (error) {
      enqueueSnackbar("Unable to proceed with UPI currently, Please try again after some time!", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
    } finally {
      setLoading(false);
    }
  }

  const handleUPIInitiate = async () => {
    setUpiModal(false);
    const reqData = {
      transactionId: currentTraxn._id,
      banktransferInfo: {
        amountTransferred: currentTraxn.pendingAmt,
      },
      paymentMethod: "UPI"
    }
    const res = await transactionServices.confirmPayment(reqData);
    if (res && res.success) {
      alert(res.data.transactionId);
      setUpiTransactionId(res.data.transactionId);
      enqueueSnackbar("Payment successful.", { variant: "success", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
      navigate("/transactions")
      // TODO: add event of UPI here
    }
    else {
      enqueueSnackbar(res?.data?.message || res?.message || "Something went wrong", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
    }
  }

  const handlePayementGateway = async () => {
    try {
      let reqData = {
        transactionId: currentTraxn._id,
        amount: currentTraxn.pendingAmt,
      };
      // throw "abchdsh"
      const res = await transactionServices.createOrderRemAmt(reqData);
      setPaymentModeModal(false);
      // console.log(res);
      if (res && res.success) {
        const order = res.data;
        const options = {
          key: order.notes.key,
          amount: order.amount,
          currency: "INR",
          name: user.name,
          description: "Purchase FRAX",
          order_id: order.id,
          // callback_url: `https://pupperazy-backend.odinflux.com/transaction/verifyOrder/${order.notes.transactionId}`,
          // callback_url: `http://192.168.0.114:5000/transaction/verifyOrder/${order.notes.transactionId}`,
          // callback_url: `http://192.168.0.109:80/transaction/verifyOrder/${order.notes.transactionId}`,
          // callback_url: `${process.env.REACT_APP_API_URL}transaction/verifyOrder/${order.notes.transactionId}`,
          // callback_url: `https://api.pupperazy.com/transaction/verifyOrder/${order.notes.transactionId}`,
          handler: async (res) => {
            // console.log(res,"test");
            enqueueSnackbar("Payment successfull.", {
              variant: "success",
              anchorOrigin: { horizontal: "center", vertical: "bottom" },
              autoHideDuration: 2000,
            });
            logsService.addLog({
              userId: user?._id,
              event: InvestorActivityEventType.PAYMENT_SUCCESSFUL,
              listingId: propertyId
            })
            // navigate("/portfolio")
            await getTransactionDetails(currentTraxn.user_id);
          },
          prefill: {
            name: user.name,
            email: user.email,
            contact: user.number,
          },
          notes: {
            address: "REALX",
          },
          theme: {
            color: "#2F6BF2",
          },
          modal: {
            escape: false,
            confirm_close: true,
            ondismiss: () => {
              // console.log("fkdhf")
            },
          },
        };
        const razor = new window.Razorpay(options);
        razor.on("payment.failed", function (response) { });
        razor.open();
      } else {
        enqueueSnackbar(res.data.message || "Something went wrong", {
          variant: "error",
          anchorOrigin: { horizontal: "center", vertical: "bottom" },
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };

  const handleBankTransferSubmit = async () => {
    try {
      let reqData = {
        transactionId: currentTraxn._id,
        amount: currentTraxn.pendingAmt,
      };
      if (reqData) {
        const req = await transactionServices.confirmSecondPartPayment(reqData);
        if (req && req.success) {
          enqueueSnackbar("Success", { variant: "success" });
          getTransactionDetails();
          setPaymentModal(false);
        } else {
          if (req.data) {
            enqueueSnackbar(req.data.message, { variant: "error" });
          } else {
            enqueueSnackbar("Something went wrong!!", { variant: "error" });
          }
        }
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };

  const handleWalletPay = async (walletPayAmount) => {
    setLoading(true);
    try {
      const reqData = {
        transactionId: currentTraxn._id,
        amount: walletPayAmount < currentTraxn.pendingAmt ? walletPayAmount : currentTraxn.pendingAmt,
      };
      const req = await transactionServices.confirmWalletPayment(reqData);
      setPaymentModeModal(false);
      if (req && req.success) {
        enqueueSnackbar("Success", { variant: "success" });
        getTransactionDetails(user?._id);
        logsService.addLog({
          userId: user?._id,
          event: InvestorActivityEventType.WALLET_PAYMENT_SUCCESSFUL,
          listingId: propertyId
        })
      } else {
        enqueueSnackbar(req?.data?.message || "Something went wrong!!", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
    setLoading(false);
  };

  if (data.length > 0) {
    return (
      <>
        {currentTraxn && (
          <ConfirmaTransaction
            commitmentDate={commitmentDate}
            open={paymentModal}
            handleClose={() => {
              setPaymentModal(false);
              getTransactionDetails(user._id);
            }}
            getTransactionDetails={getTransactionDetails}
            amtPaid={currentTraxn?.amtPaid || 0}
            data={{ transactionId: currentTraxn?._id }}
            amount={currentTraxn?.amount || 0}
            amtTobePaid={currentTraxn?.amtTobePaid}
            entityId={
              entityType === "FAMILYMEMBER" ? user._id : entityId || user._id
            }
            entityType={entityType}
            listingId={currentTraxn?.listingId}
            tokenName={tokenName}
          />
        )}
        <PaymentMode
          open={paymentModeModal}
          handleClose={() => setPaymentModeModal(false)}
          onBankTransfer={handleBankTransfer}
          onPaymentGateway={handlePayementGateway}
          onUPI={onUPI}
          isUPIEnabled={false}
          onWalletPay={handleWalletPay}
          walletPayAmount={currentTraxn?.pendingAmt}
          loading={loading}
        />

        {huftransaction.length == 0 &&
          familymemberTransaction.length == 0 &&
          trusttransaction.length == 0 && (
            isMobile ? (
              <Box pb={{ xl: "0px", lg: "0px", md: "0px", xs: "77px" }}>
                <TransactionsCardList
                  rows={data}
                  showPaymentAccount={true}
                  renderAmount={renderAmount}
                  onCompleteRemainingPayment={handleCompleteRemainingPayment}
                  onViewPayments={handleViewPayments}
                  emptyState={
                    <EmptyTableState
                      showAction={false}
                      title={"No Transactions Available"}
                      subtitle={""}
                    />
                  }
                />
              </Box>
            ) : (
              <DataGridTable initialColumns={table} initialRows={data} />
            )
          )}

        {(huftransaction.length > 0 ||
          familymemberTransaction.length > 0 ||
          trusttransaction.length > 0) && (
            <Box pb={{ xl: "0px", lg: "0px", md: "0px", xs: "77px" }}>
              <Box sx={{ mt: { md: 2, xs: 2 } }}>
                <Stack>
                  <Box mb={3}>
                    <Box sx={{ mx: "46px" }}>
                      {data && (
                        <Tabs
                          activeTab={activeTab}
                          tabs={tabs}
                          onClick={handleTabClick}
                        />
                      )}
                    </Box>
                    <Divider
                      sx={{
                        width: "calc(100% + 80px)",
                      }}
                    />
                  </Box>

                  <Box>{tabs[activeTab]?.tab}</Box>
                </Stack>
              </Box>

              {/* } */}
            </Box>
          )}
        {openTransactionModal && (
          <ModalComponent
            open={openTransactionModal}
            handleClose={() => setOpenTransationModal((prev) => !prev)}
            title="All Payments"
            // fullScreen={isMobile}
            titleStyle={{
              fontWeight: 400,
              mb: 1,
              pl: 1,
              fontSize: "1.4rem !important",
            }}
            children={
              <AllTransactionByListing
                tokenName={tokenName}
                data={transactionProp}
                status={status}
                noOfFrax={noOfFrax}
                propertyId={propertyId}
                overflowX={"auto"}
              />
            }
          />
        )}
      </>
    );
  } else if (tableLoading) {
    return isMobile ? (
      <TransactionsCardsSkeleton />
    ) : (
      <DataGridTable initialColumns={table} initialRows={[]} />
    );
  } else {
    return (
      <EmptyTableState
        showAction={false}
        title={"No Transactions Available"}
        subtitle={""}
      />
    );
  }
};

export const AllTranSaction = ({ data, table, setPaymentAccount }) => {
  setPaymentAccount(true);
  return <DataGridTable initialColumns={table} initialRows={data} />;
};

export const PersonalTransaction = ({ data, table, setPaymentAccount }) => {
  setPaymentAccount(false);
  return <DataGridTable initialColumns={table} initialRows={data} />;
};
export const FamilyMemberTransaction = ({ data, table, setPaymentAccount }) => {
  setPaymentAccount(true);
  return <DataGridTable initialColumns={table} initialRows={data} />;
};
export const HUFTransaction = ({ data, table, setPaymentAccount }) => {
  setPaymentAccount(false);
  return <DataGridTable initialColumns={table} initialRows={data} />;
};
export const TrustTransaction = ({ data, table, setPaymentAccount }) => {
  setPaymentAccount(false);
  return <DataGridTable initialColumns={table} initialRows={data} />;
};